// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Icon from "../images-and-icons/Icon.res.js";
import * as Hover from "../../primitives/Hover.res.js";
import * as React from "react";
import * as Inline from "../layout-and-structure/Inline.res.js";
import * as Touchable from "../../primitives/Touchable.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
let styles = {
  text: {
    "font-kVVagm": "font-x1tf9s6z",
    "marginLeft-koQZXg": "marginLeft-x1swdo50",
    $$css: "wino-gc:src/resources/navigation/GoBackButton.res.js:21"
  },
  defaultText: {
    "color-kMwMTN": "color-x1i7sqjx",
    $$css: "wino-gc:src/resources/navigation/GoBackButton.res.js:25"
  },
  hoveredText: {
    "color-kMwMTN": "color-x1d0e3gf",
    $$css: "wino-gc:src/resources/navigation/GoBackButton.res.js:28"
  }
};
function textStyleFromParams(hovered) {
  if (hovered) {
    return styles.hoveredText;
  } else {
    return styles.defaultText;
  }
}
function GoBackButton(props) {
  let match = Navigation.useGoBack();
  let onGoBack = match[1];
  let canGoBack = match[0];
  let match$1 = Hover.use(undefined, undefined, undefined);
  let hovered = match$1[1] && canGoBack;
  let newrecord = {
    ...{
      className: "alignItems-x6s0dn4 display-x78zum5 flexDirection-x1q0g3np gap-x195vfkc",
      "data-style-src": "wino-gc:src/resources/navigation/GoBackButton.res.js:15"
    }
  };
  newrecord.ref = Primitive_option.some(match$1[0]);
  let newrecord$1 = {
    ...Stylex.props(styles.text, textStyleFromParams(hovered))
  };
  newrecord.children = [JsxRuntime.jsx(Icon.make, {
    name: "arrow_left",
    fill: hovered ? "#797885" : "#bdbdca",
    width: 16,
    height: 16,
    bold: true
  }), JsxRuntime.jsx("span", (newrecord$1.children = I18n.t("Back"), newrecord$1))];
  return JsxRuntime.jsx(Inline.make, {
    children: JsxRuntime.jsx(Touchable.make, {
      children: JsxRuntime.jsxs("div", newrecord),
      disabled: !canGoBack,
      onPress: param => onGoBack()
    })
  });
}
let make = React.memo(GoBackButton);
export { make };
/* styles Not a pure module */